import { setWorkspaceDirtyLabels } from './workspaceDirtyRegistry';

export const setActiveMatchDirtyLabels = (labels: string[]): void => { setWorkspaceDirtyLabels('football-forms', labels); };
